import React from 'react'
import { Quicklink } from '@node-space/storybook-components/dist/Quicklink'
import { Box, Icon } from '@node-space/ui-components'
import { EmbeddedCustomerAgreement } from '../helpers/types'
import { CustomerAgreementStatusHighlight } from './CustomerHighlight'

export interface EmbeddedCustomerAgreementsProps {
  agreements: EmbeddedCustomerAgreement[]
}

export const EmbeddedCustomerAgreements = ({ agreements }: EmbeddedCustomerAgreementsProps) => {
  return (
    <Box>
      {agreements?.map(agreement => (
        <Box flexCol gap={8} key={agreement?.name}>
          <Quicklink
            to={agreement?.url}
            text={agreement?.name}
            iconElement={<Icon name="DownloadSimple" />}
          />
          <Box>
            <CustomerAgreementStatusHighlight status={agreement?.status} />
          </Box>
        </Box>
      ))}
    </Box>
  )
}
